<template>
    <div class="inbound-audit clearfix">
        <Form :labelWidth="150" ref="auditForm" :model="formData">
            <FormItem label=" " prop="approve" :rules="required">
                <RadioGroup v-model="formData.approve" @on-change="handleApprove">
                    <Radio :label="true">{{
                        $t("fbb.inbound.pass_audit", {
                            defaultValue: "审核通过",
                        })
                    }}</Radio>
                    <Radio :label="false">{{
                        $t("fbb.inbound.back_audit", {
                            defaultValue: "审核拒回",
                        })
                    }}</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem v-if="showWarehouse" label="入库仓库" prop="orgWarehouseId" :rules="required">
                <Select
                    style="width: 70%"
                    v-model="formData.orgWarehouseId"
                    filterable
                >
                    <Option v-for="item in warehouseList" :key="item.id" :value="item.id">{{item.code}}({{item.title}})</Option>
                </Select>
                <Button class="margin-left-15" type="primary" @click="autoCal"
                    >自动计算</Button
                >
            </FormItem>
            <FormItem
                v-if="showCapacity"
                :label="
                    $t('fbb.inbound.product_volume', {
                        defaultValue: '产品总体积(CBM)',
                    })
                "
            >
                <div class="font-bold">{{ propsData.totalVolume }}</div>
            </FormItem>
            <FormItem
                v-if="showCapacity"
                label="当前客户库容余量/库容总余量/当前客户总库容(CBM)"
            >
                <div class="font-bold">
                    {{ propsData.restCapacity }}/{{
                        propsData.totalRestCapacity
                    }}/{{ propsData.totalCapacity }}
                </div>
            </FormItem>
            <FormItem
                v-if="showInboundVolume"
                :label="
                    $t('fbb.inbound.month_volume', {
                        defaultValue: '当月入库量(CBM)',
                    })
                "
            >
                <div class="font-bold">{{ propsData.monthVolume }}</div>
            </FormItem>
            <FormItem
                v-if="showInboundVolume"
                :label="
                    $t('fbb.inbound.quarter_volume', {
                        defaultValue: '当季入库量(CBM)',
                    })
                "
            >
                <div class="font-bold">{{ propsData.quarterVolume }}</div>
            </FormItem>
            <FormItem
                :label="$t('global.common.notes', { defaultValue: '备注' })"
                prop="remark"
            >
                <Input
                    style="width: 70%"
                    v-model="formData.remark"
                    type="textarea"
                    :rows="3"
                />
            </FormItem>
        </Form>
        <div class="button-container pull-right">
            <Button type="primary" @click="submit">提交</Button>
            <Button
                class="margin-left-15"
                type="default"
                @click="$emit('on-close')"
                >取消</Button
            >
        </div>
        <compModal v-model="modalProps.show" v-bind="modalProps">
            <component
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
            ></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpCheckInboundBill,
    HttpGetWarehouseByAreaId
} from '@/service/inbound';
import compAutocal from "./autocal";
export default {
    props: ["id", "propsData", "showCapacity", "showInboundVolume"],
    components: {
        compAutocal
    },
    data() {
        return {
            formData: {
                approve: true
            },
            modalProps: {
                show: false,
            },
            warehouseList: [],
            loading: false,
            required: [{
                required: true,
                message: this.$t('global.form.required', { defaultValue: "该信息不能为空,请填写" })
            }]
        };
    },
    async created () {
        if (this.propsData.areaId) {
            this.loading = true;
            await HttpGetWarehouseByAreaId({
                areaId: this.propsData.areaId,
                contextId: this.propsData.organizationId
            }).then(res => {
                this.warehouseList = res.data;
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        }
    },
    computed: {
        showWarehouse () {
            return this.formData.approve && this.propsData.areaId;
        }
    },
    methods: {
        handleApprove (value) {
            if (!value) this.formData.orgWarehouseId = null;
        },
        autoCal() {
            this.modalProps = {
                title: "分仓计算结果",
                show: true,
                width: 800,
                component: "compAutocal",
                showFooter: false,
                id: this.id,
                areaId: this.propsData.areaId,
                on: {
                    "on-select-warehouse": (orgWarehouseId) => {
                        // this.formData.orgWarehouseId = orgWarehouseId;
                        this.$set(this.formData, "orgWarehouseId", orgWarehouseId);
                        this.modalProps.show = false;
                    }
                }
            };
        },
        async submit () {
            let flag = true;
            await this.$refs.auditForm.validate(valid => {
                return flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            await HttpCheckInboundBill({
                id: this.id,
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
    },
};
</script>

<style>
</style>